import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme';

export interface ScrollBorderReactWindowClasses {
	/** styles applied to the root element */
	root: string;
	hasOverflow: string;
	scrolled: string;
	scrolledToEnd: string;
	scrollSentinel: string;

	scrollBorderBottom: string;
	scrollBorderTop: string;
	scrollWrapper: string;
}

export const getScrollBorderReactWindowUtilityClass = (slot: string) =>
	generateUtilityClass('ScrollBorderReactWindow', slot);

export const scrollBorderReactWindowClasses = generateUtilityClasses<
	keyof ScrollBorderReactWindowClasses
>('ScrollBorderReactWindow', [
	'root',
	'hasOverflow',
	'scrolled',
	'scrolledToEnd',
	'scrollBorderBottom',
	'scrollBorderTop',
	'scrollSentinel',
	'scrollWrapper',
]);
export default scrollBorderReactWindowClasses;
